/**
 * SideMenuList.js - Histopathology-only project (per BRD).
 * Returns menu config for Histopathology module only.
 */
import { localGetItem } from "./Services/CacheProviderService";
import ImagePaths from "./ImagePaths";
import { canViewSideMenu } from "./Services/RoleAccessService";

export const NewSideMenu = {
  Histopathology: () => {
    const myUser = JSON.parse(localGetItem("loggedInUserInfo") || "{}");
    const newList = [];
    if (myUser?.module_name === "Histopathology") {
      const allItems = [
        { id: 1, menuName: "Histopathology Home", OnIcon: ImagePaths.HistoBillingFill, OffIcon: ImagePaths.HistoBilling, label: "Billing" },
        { id: 2, menuName: "Histopathology Specimen", OnIcon: ImagePaths.HistoSpecimanFill, OffIcon: ImagePaths.HistoSpeciman, label: "Specimen" },
        { id: 3, menuName: "Histopathology Reporting", OnIcon: ImagePaths.HistoReportingFill, OffIcon: ImagePaths.HistoReporting, label: "Reporting" },
        { id: 4, menuName: "Histopathology Credit Settlement", OnIcon: ImagePaths.Settlementon, OffIcon: ImagePaths.Settlementoff, label: "Credit Settlement" },
        { id: 5, menuName: "Histopathology Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: "Reports" },
        { id: 6, menuName: "Histopathology Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Masters" },
      ];
      allItems.filter((item) => canViewSideMenu(item.label)).forEach((item) => newList.push(item));
    }
    return newList;
  },
  default: () => [],
};

export function getSideMenus() {
  const myUser = JSON.parse(localGetItem("loggedInUserInfo") || "{}");
  return myUser?.module_name === "Histopathology" ? NewSideMenu.Histopathology() : NewSideMenu.default();
}
